import type { UdsTokens } from '@sunwebgroup/ui-components'
import type { ComponentPropsWithoutRef } from 'react'
import { Layout } from '@sunwebgroup/uds-ui/layout'
import * as React from 'react'
import { useRef } from 'react'
import { useIntl } from '@/intl'
import { Logo, LogoCompact } from '../Logo'
import styles from './HeaderContainer.module.css'

interface HeaderContainerProps extends ComponentPropsWithoutRef<'header'> {
  backgroundColor?: 'transparent' | keyof UdsTokens
}

export function HeaderContainer({
  backgroundColor,
  children,
}: React.PropsWithChildren<HeaderContainerProps>) {
  const ref = useRef<HTMLDivElement>(null)
  const intl = useIntl()

  const backgroundColorStyle = backgroundColor
    ? { '--_background-color': backgroundColor === 'transparent' ? 'transparent' : `var(--${backgroundColor.replaceAll('_', '-')})` } as React.CSSProperties
    : undefined

  return (
    <header id="navigation" ref={ref} className={styles.wrapper} style={backgroundColorStyle}>
      <Layout className={styles.headerLayout}>
        <a href="/" aria-label={intl.formatMessage({ id: 'link_home' })} data-qa="header-logo-link">
          <Logo className={styles.logo} />
          <LogoCompact className={styles.logoCompact} />
        </a>
        {children}
      </Layout>
    </header>
  )
}
